"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var reactNode_1 = require("../util/reactNode");
var types_1 = require("../util/types");
var SpinSizes = (0, types_1.tuple)('small', 'default', 'large');
// Render indicator
var defaultIndicator = null;
function renderIndicator(prefixCls, props) {
    var indicator = props.indicator;
    var dotClassName = "".concat(prefixCls, "-dot");
    // should not be render default indicator when indicator value is null
    if (indicator === null) {
        return null;
    }
    if ((0, reactNode_1.isValidElement)(indicator)) {
        return (0, reactNode_1.cloneElement)(indicator, {
            className: (0, classnames_1.default)(indicator.props.className, dotClassName),
        });
    }
    if ((0, reactNode_1.isValidElement)(defaultIndicator)) {
        return (0, reactNode_1.cloneElement)(defaultIndicator, {
            className: (0, classnames_1.default)(defaultIndicator.props.className, dotClassName),
        });
    }
    return (React.createElement("span", { className: "iconfont anticon-spin loadingIcon ".concat(prefixCls, "-dot") },
        React.createElement("span", { className: "".concat(prefixCls, "-dot-icon") })));
}
function shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
var Spin = /** @class */ (function (_super) {
    tslib_1.__extends(Spin, _super);
    function Spin(props) {
        var _this = _super.call(this, props) || this;
        _this.debouncifyUpdateSpinning = function (props) {
            var delay = (props || _this.props).delay;
            if (delay) {
                _this.cancelExistingSpin();
                _this.updateSpinning = (0, debounce_1.default)(_this.originalUpdateSpinning, delay);
            }
        };
        _this.updateSpinning = function () {
            var spinning = _this.props.spinning;
            var currentSpinning = _this.state.spinning;
            if (currentSpinning !== spinning) {
                _this.setState({ spinning: spinning });
            }
        };
        _this.renderSpin = function (_a) {
            var _b, _c;
            var getPrefixCls = _a.getPrefixCls, direction = _a.direction;
            var _d = _this.props, customizePrefixCls = _d.prefixCls, className = _d.className, size = _d.size, tip = _d.tip, wrapperClassName = _d.wrapperClassName, style = _d.style, restProps = tslib_1.__rest(_d, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
            var spinning = _this.state.spinning;
            var prefixCls = getPrefixCls('spin', customizePrefixCls);
            var spinClassName = (0, classnames_1.default)(prefixCls, (_b = {},
                _b["".concat(prefixCls, "-sm")] = size === 'small',
                _b["".concat(prefixCls, "-lg")] = size === 'large',
                _b["".concat(prefixCls, "-spinning")] = spinning,
                _b["".concat(prefixCls, "-show-text")] = !!tip,
                _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
                _b), className);
            // fix https://fb.me/react-unknown-prop
            var divProps = (0, omit_1.default)(restProps, ['spinning', 'delay', 'indicator']);
            var spinElement = (React.createElement("div", tslib_1.__assign({}, divProps, { style: style, className: spinClassName }),
                renderIndicator(prefixCls, _this.props),
                tip ? React.createElement("div", { className: "".concat(prefixCls, "-text") }, tip) : null));
            if (_this.isNestedPattern()) {
                var containerClassName = (0, classnames_1.default)("".concat(prefixCls, "-container"), (_c = {},
                    _c["".concat(prefixCls, "-blur")] = spinning,
                    _c));
                return (React.createElement("div", tslib_1.__assign({}, divProps, { className: (0, classnames_1.default)("".concat(prefixCls, "-nested-loading"), wrapperClassName) }),
                    spinning && React.createElement("div", { key: "loading" }, spinElement),
                    React.createElement("div", { className: containerClassName, key: "container" }, _this.props.children)));
            }
            return spinElement;
        };
        var spinning = props.spinning, delay = props.delay;
        var shouldBeDelayed = shouldDelay(spinning, delay);
        _this.state = {
            spinning: spinning && !shouldBeDelayed,
        };
        _this.originalUpdateSpinning = _this.updateSpinning;
        _this.debouncifyUpdateSpinning(props);
        return _this;
    }
    Spin.setDefaultIndicator = function (indicator) {
        defaultIndicator = indicator;
    };
    Spin.prototype.componentDidMount = function () {
        this.updateSpinning();
    };
    Spin.prototype.componentDidUpdate = function () {
        this.debouncifyUpdateSpinning();
        this.updateSpinning();
    };
    Spin.prototype.componentWillUnmount = function () {
        this.cancelExistingSpin();
    };
    Spin.prototype.cancelExistingSpin = function () {
        var updateSpinning = this.updateSpinning;
        if (updateSpinning && updateSpinning.cancel) {
            updateSpinning.cancel();
        }
    };
    Spin.prototype.isNestedPattern = function () {
        return !!(this.props && typeof this.props.children !== 'undefined');
    };
    Spin.prototype.render = function () {
        return React.createElement(config_provider_1.ConfigConsumer, null, this.renderSpin);
    };
    Spin.defaultProps = {
        spinning: true,
        size: 'default',
        wrapperClassName: '',
    };
    return Spin;
}(React.Component));
exports.default = Spin;
//# sourceMappingURL=index.js.map